import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { Template } from "types/Template";
import { handleRequestError } from "utils/Request";

export async function fetchAdminTemplates(): Promise<Template[]> {
  const { data } = await api.get('/admin/templates');
  return data;
}

export function useAdminTemplates() {
  const query = useQuery('admin-templates', fetchAdminTemplates);

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Ocorreu um erro ao listar os templates. Por favor, tente novamente!');
  }, [query.isError, query.error]);

  return query;
}
